import * as R from 'ramda'

const ascByName = (array) =>
  R.sort(R.ascend(R.compose(R.toLower, R.prop('name'))))(array)

export default ascByName
